import { defineStore } from 'pinia';
/* import { useModuleStore } from '../moduleStore';
import AdminService from '@/services/admin.service'; */

export const useCampaignStore = defineStore('campaign', {
    state: () => ({
        current_step: 1,
        id: null,
        id_contacts_list: null,
        name: "",
        pre_header: "",
        send_at: null,
        status: "draft",
        subject: "",
        blocks_content: [],
        campaign_emails: [],
        content: "",
        created_at: "",
    }),
    actions: {
        // Actions pour gérer les blocs de contenu
        addBlock(block) {
            this.blocks_content.push(block)
        },

        updateBlock(index, data) {
            if (this.blocks_content[index]) {
                this.blocks_content[index] = { ...this.blocks_content[index], ...data }
            }
        },

        deleteBlock(index) {
            this.blocks_content.splice(index, 1)
        },

        duplicateBlock(index) {
            const originalBlock = this.blocks_content[index]
            if (originalBlock) {
                const duplicatedBlock = { ...originalBlock, id: `block_${Date.now()}_${Math.random().toString(36).substr(2, 9)}` }
                this.blocks_content.splice(index + 1, 0, duplicatedBlock)
            }
        },

        reorderBlocks(fromIndex, toIndex) {
            const block = this.blocks_content[fromIndex]
            this.blocks_content.splice(fromIndex, 1)
            this.blocks_content.splice(toIndex, 0, block)
        },

        clearBlocks() {
            this.blocks_content = []
        },

        setBlocks(blocks) {
            this.blocks_content = blocks
        }
    }
});